import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  faArrowLeft,
  faUpRightFromSquare,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import {
  FileType,
  GlobalFunctions
} from 'globales-projekt-angular';
import { FileAppMetaDatas } from 'src/app/data/anwendung/file-app-meta-datas.model';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import { DateiTyp } from 'src/app/immutable/enums/datei-typ';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-definition-und-anwendungsbereich',
  templateUrl: './definition-und-anwendungsbereich.component.html',
  styleUrls: ['./definition-und-anwendungsbereich.component.css'],
})
export class DefinitionUndAnwendungsbereichComponent implements OnInit {
  showWaitingForDataSpinner: number = 0;
  anwendungsname: string = ConstantsTexte.ANWENDUNGSNAME;
  faArrowLeft: IconDefinition = faArrowLeft;
  faUpRightFromSquare: IconDefinition = faUpRightFromSquare;

  fileAppMetaDatas: FileAppMetaDatas = new FileAppMetaDatas(this.apiService);

  cssString: string;

  constructor(private apiService: ApiService, private location: Location) {}

  ngOnInit(): void {
    this.cssString = GlobalFunctions.setNavBarDropdownRedColorSelect();

    this.fileAppMetaDatas.loadFileAppMetaDatas();
  }

  goBack() {
    this.location.back();
  }

  openInTabVerordnung() {
    this.openInTab(this.fileAppMetaDatas.verordnung.type, DateiTyp.VERORDNUNG);
  }

  openInTabBetriebsgroessenklassen() {
    this.openInTab(
      this.fileAppMetaDatas.betriebsgroessenklassen.type,
      DateiTyp.BETRIEBSGROESSENKLASSEN
    );
  }

  openInTab(type: FileType, dateiTyp: DateiTyp) {
    this.showWaitingForDataSpinner++;
    this.apiService.getAppFileDocuments(dateiTyp).subscribe((response) => {
      GlobalFunctions.openInTab(response, type);
      this.showWaitingForDataSpinner--;
    });
  }

  public ngOnDestroy() {
    GlobalFunctions.setNavBarDropdownRedColorDeSelect(this.cssString);
  }
}
